export const NEWS_MAX_AMOUNT = 12;

export const NEWS_CATEGORY = {
  LAB: "lab",
  OUTREACH: "outreach",
}

export const newsList = [
  {
    date: "2026/08/20",
    title: "Kevin received the 3rd place poster award on 85th PEC! What a nice way to end Ph.D.",
    category: NEWS_CATEGORY.LAB,
    new: true,
    images: [
      "/news/PEC-Kevin.jpg",
    ],
  },
  {
    date: "2026/08/19",
    title: "Jennifer gave an oral presentation on the 85th PEC in San Diego.",
    category: NEWS_CATEGORY.LAB,
    new: true,
  },
  {
    date: "2026/08/19",
    title: "Fang gave an invited oral presentation on the 85th PEC in San Diego!",
    category: NEWS_CATEGORY.LAB,
    new: true,
  },
  {
    date: "2026/08/17",
    title: "Congratulations on Kevin completing Ph.D. requirements!",
    category: NEWS_CATEGORY.LAB,
    new: true,
  },
  {
    date: "2026/08/12",
    title: "Welcome Alexander Bachtold Ricoy to join the lab.",
    category: NEWS_CATEGORY.LAB,
    new: true,
  },
  {
    date: "2026/06/17",
    title: "Jennifer gave an oral presentation on 30th annual Green Chemistry and Engineering Conference.",
    category: NEWS_CATEGORY.LAB,
    new: true,
  },
  {
    date: "2026/06/17",
    title: "Bishal gave a poster presentation on 30th annual Green Chemistry and Engineering Conference.",
    category: NEWS_CATEGORY.LAB,
    new: true,
  },
  {
    date: "2026/04/14",
    title: "Anastasiia Gordeeva gave a poster presentation at National Conference on Undergraduate Research, Richmond, VA.",
    category: NEWS_CATEGORY.LAB,
    new: true,
  },
  {
    date: "2026/03/10",
    title: "Anastasiia Gordeeva gave an oral and a poster presentations at Pittcon, San Antonio, TX.",
    category: NEWS_CATEGORY.LAB,
    new: true,
  },
  {
    date: "2026/01/06",
    title: "The new MATRIX 4 arrived. STREAM STM now has a new controller. Hooray!",
    category: NEWS_CATEGORY.LAB,
    new: true,
  },
  {
    date: "2025/12/19",
    title: "Xu lab end-of-the-year group activity is escape the room! We successfully escaped the Mysterious Market in the last minute.",
    category: NEWS_CATEGORY.LAB,
    new: true,
  },
  {
    date: "2025/10/29",
    title: "Welcome Rafael Flores to the lab!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2025/09/25",
    title: "Jennifer Sanchez gave an oral presentation at the 71th AVS International Symposium and Exhibition, Charlotte, NC!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2025/08/27",
    title: "Welcome Thomas Garcia to the lab!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2025/07/23",
    title: "SR860 external lock-in amplifier was installed on MATRIX. We can now collect high quality dI/dV curves!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2025/07/14",
    title: "Kevin gave an oral presentation at MSC - Microscopical Society of Canada!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2025/06/08",
    title: "Dahee presented at the 29th North American Catalysis Society Meeting (NAM29)!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2025/01/30",
    title: "Welcome Anastasiia Gordeeva to the lab!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2025/1/29",
    title: "Congratulations to Dahee on receiving the UTSA Initiative for Maximizing Student Development (IMSD) fellowship!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2024/12/6",
    title: "Kevin and Dahee joined the Demo Day at Myers Elementary School and did science experiment demonstrations to about 60 4th graders!",
    category: NEWS_CATEGORY.OUTREACH,
    images: [
      "/news/demo-day.jpg",
    ],
  },
  {
    date: "2024/10/26",
    title: "Xu Lab hosted an open house at UTSA DAY! Thank Kevin, Dahee, and Bishal for the service!",
    category: NEWS_CATEGORY.OUTREACH,
    images: [
      "/news/2024UTSA-day-1.jpg",
      "/news/2024UTSA-day-2.jpg",
    ],
  },
  {
    date: "2024/10/25",
    title: "Dr. Xu gave an invited talk and an introduction of the UTSA graduate program in chemistry at Texas Lutheran University!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2024/10/24",
    title: "Dahee participated in the 3MT® Research Competition and won a third place with a $500 financial award!",
    category: NEWS_CATEGORY.LAB,
    images: [
      "/news/striking precision.jpg",
    ],
  },
  {
    date: "2024/10/20",
    title: "Dr. Xu gave an invited talk at Southwest Regional Meeting of the American Chemical Society (SWRM), Waco, TX!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2024/08/19",
    title: "Kevin prsented a research talk at the 13th International Conference on LEEM PEEM, Montréal, Canada!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2024/06/16",
    title: "Dahee prsented a poster at the Catalysis Gordon Research Conference, New London, NH!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2024/05/31",
    title: "Dr. Xu presented a research talk on the 2024 Electron, Ion and Photon Beam Technology and Nanofabrication (EIPBN) and received the Best Scanning Probe Micograph in the Micrograph Contest, La Jolla, CA!",
    category: NEWS_CATEGORY.LAB,
    images: [
      "/news/micrograph contest.jpg",
    ],
  },
  {
    date: "2024/05/03",
    title: "Erik from Striking Precision Welding and Fabrication fixed the cracked welding connection of the VT-STM system on site. Thank you, Erik!",
    category: NEWS_CATEGORY.LAB,
    images: [
      "/news/striking precision.jpg",
    ],
  },
  {
    date: "2024/04/20",
    title: "Dr. Xu hosted a table at the Viva Science Day.",
    category: NEWS_CATEGORY.OUTREACH,
    images: [
      "/news/Viva science.jpg",
    ],
  },
  {
    date: "2024/02/24",
    title: "Dr. Xu and Dr. Agudelo hosted a table and showed kids a dry ice bubble experiment at the KLRNs S.E.E Your Future Career Day",
    category: NEWS_CATEGORY.OUTREACH,
    images: [
      "/news/KLRN.jpg",
      "/news/KLRN-2.jpg",
    ],
  },
  {
    date: "2024/02/18",
    title: "Xu Lab hosted a total of 50-60 students on a lab tour during UTSA Day! Special thanks to Bishal and Jennifer!",
    category: NEWS_CATEGORY.OUTREACH,
  },
  {
    date: "2024/02/16",
    title: "Congratulations to Dahee on receiving the PURF fellowship for the spring semester of 2024!",
    category: NEWS_CATEGORY.LAB,
    },
  {
    date: "2024/01/11",
    title: "Welcome, Mr. Austin Herrod, to Xu Lab as an undergraduate researcher!",
    category: NEWS_CATEGORY.LAB,
  }, 
  {
    date: "2024/01/05",
    title: "Welcome, Mr. Bishal Gautum, to Xu Lab as a Ph.D. student!",
    category: NEWS_CATEGORY.LAB,
  }, 
  {
    date: "2023/12/11",
    title: "After a long-distance journey, the VT-STM from Harvard University has arrived. Hooray!",
    category: NEWS_CATEGORY.LAB,
  }, 
  {
    date: "2023/11/16",
    title: "Xu Lab has expanded to BSE 0.224, increasing the total lab space to 1600 square feet.",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2023/10/26",
    title: "Undergraduate Mr. Adam Buratowski will conduct an independent study in Xu Lab in the spring of 2024!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2023/09/23",
    title: "Welcome, Mr. John Leija, to Xu Lab as an undergraduate researcher!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2023/09/22",
    title: "Congratulations to Dr. Xu on receiving a DOE-BES-FAIR grant as the lead PI!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2023/06/07",
    title: "A special thanks to Harvard University and Prof. Cynthia Friend for donating an advanced ScientaOmicron VT-STM system to Xu Lab!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2023/04/25",
    title: "Congratulations to Jennifer on receiving the Abrams Fellowship!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2022/11/17",
    title: "Congratulations to Bernice on passing her presentation for a non-thesis M.S. degree!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2022/11/15",
    title: "The customized preparation chamber was attached to the STREAM STM in November 2022!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2022/07/23",
    title: "Welcome, Ms. Jennifer Sanchez, to Xu Lab as a Ph.D. student!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2022/08/11",
    title: "Congratulations to Dr. Xu on receiving an NSF award as a co-PI!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2022/06/16",
    title: "The STREAM STM has passed the on-site test, achieving atomic resolution of HOPG at 85 K!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2022/04/25",
    title: "Congratulations to Kevin on receiving the Abrams Fellowship!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2021/11/10",
    title: "Undergraduate students from UTSA ACS visited the Xu Lab. Kevin and Bernice introduced our research and gave a demo of in-air STM and STM probe preparation. Cheers!",
    category: NEWS_CATEGORY.OUTREACH,
  },
  {
    date: "2021/10/01",
    title: "Welcome, Ms. Bernice Adeeso, to the Xu lab as a M.S. student!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2021/09/15",
    title: "The new STREAM STM from ScientaOmicron has arrived in the Xu Lab!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2021/08/15",
    title: "Welcome, Mr. Kevin Sutherland, to the Xu lab as a Ph.D. student!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2021/06/30",
    title: "Congratulations to Nathan on completing his undergraduate studies!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2021/05/15",
    title: "Welcome, Mr. Nathan McLane and Mr. Reese Roddy, to the Xu lab as undergraduate researchers!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2021/04/28",
    title: "Welcome, Ms. Dahee Lee, to the Xu lab as an undergraduate researcher!",
    category: NEWS_CATEGORY.LAB,
  },
  {
    date: "2021/04/22",
    title: "Lab renovation started on 11/30/2020 and was completed on 04/22/2021! ",
    category: NEWS_CATEGORY.LAB,
  },
];